import { render, staticRenderFns } from "./px-questionary.vue?vue&type=template&id=5519d50f&scoped=true&"
import script from "./px-questionary.vue?vue&type=script&lang=ts&"
export * from "./px-questionary.vue?vue&type=script&lang=ts&"
import style0 from "./px-questionary.vue?vue&type=style&index=0&id=5519d50f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5519d50f",
  null
  
)

export default component.exports